// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section-module--wrapper--1R64p","dark":"Section-module--dark--15vxo","darkBG":"Section-module--darkBG--1kExD"};